/**
 * SEOListContainer
 * --
 */
import React from 'react';
import SEOListPresenter from './SEOListPresenter';

const SEOListContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <SEOListPresenter />
    </>
  );
};

export default SEOListContainer;
